import React, { useState, useEffect } from "react";
import "../styles/Admin.css";

function Users() {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]); // **لیست فیلترشده**
  const [searchTerm, setSearchTerm] = useState(""); // **متغیر جستجو**
  const [sortByConfirmed, setSortByConfirmed] = useState(false); // **مرتب‌سازی بر اساس تأیید ایمیل**

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    let filtered = users.filter((u) =>
      u.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      u.email.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (sortByConfirmed) {
      filtered = filtered.sort((a, b) => b.isEmailConfirmed - a.isEmailConfirmed);
    }

    setFilteredUsers(filtered);
  }, [searchTerm, users, sortByConfirmed]);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(`${API_BASE_URL}/Admin/getusers`, {
        method: "GET",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      if (!response.ok) throw new Error("Failed to fetch users");
      
      const data = await response.json();
      setUsers(data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setError("Error fetching users.");
      setLoading(false);
    }
  };

  const Access = async (userId) => {
    if (!window.confirm("Are you sure you want to verify or unverify this user?")) return;
  
    try {
      const token = localStorage.getItem("userToken");
  
      const response = await fetch(`${API_BASE_URL}/Admin/setorunsetaccess/${userId}`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
         },
      });
  
      if (!response.ok) throw new Error("Failed to verify user");
  
      const updatedUsers = users.map((u) =>
        u.id === userId ? { ...u, access: !u.access } : u
      );
  
      setUsers(updatedUsers);
    } catch (error) {
      console.error("Error verifying user:", error);
      alert("Failed to verify user.");
    }
  };

  const deleteuser = async (userId) => {
    if (!window.confirm("Are you sure you want to delete this user?")) return;
  
    try {
      const token = localStorage.getItem("userToken");
  
      const response = await fetch(`${API_BASE_URL}/Admin/deleteuser/${userId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
  
      const result = await response.json();

      if (!response.ok) {
        alert(result || "Failed to delete user.");
        return;
      }
  
      alert(result.message || "User deleted successfully.");
      setUsers(users.filter((u) => u.id !== userId)); 
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("Something went wrong.");
    }
  };
  
  const setadmin = async(userId) =>{
    if (!window.confirm("Are you sure you want to change roll this user?")) return;
  
    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(`${API_BASE_URL}/Admin/setorunsetadmin/${userId}`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
         },
      });
  
      if (!response.ok) throw new Error(response.error);
  
      const updatedUsers = users.map((u) =>
        u.id === userId ? { ...u, isAdmin: !u.isAdmin } : u
      );
  
      setUsers(updatedUsers);
    } catch (error) {
      console.error("Error changing roll user:", error);
      alert("Failed to change roll user.");
    }
  }

  const EmailConfirmation = async(userId) => {
    console.log(userId);
  }

  const toggleSortByConfirmed = () => {
    setSortByConfirmed((prev) => !prev);
  };

  return (
    <div>
      <h2>👤 Users Management</h2>

      <input
        type="text"
        placeholder="Search by username or email..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : users.length === 0 ? (
        <p>No users found.</p>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Username</th>
              <th>Email</th>
              <th>Role</th>
              <th>Access</th>
              <th style={{ cursor: "pointer" }} onClick={toggleSortByConfirmed}>
                EmailConfirmed {sortByConfirmed ? "🔼" : "🔽"}
              </th>
              <th>EmailConfirmation</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user, index) => (
              <tr key={user.id}>
                <td>{index + 1}</td> {/* شماره ردیف پیوسته */}
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td style={{ cursor: "pointer" }} onClick={() => setadmin(user.id)}>
                  {user.isOwner ? "Owner" : user.isAdmin ? "Admin" : "User"}
                </td>
                <td style={{ cursor: "pointer" }} onClick={() => Access(user.id)}>
                  {user.access ? "✅ Yes" : "❌ No"}
                </td>
                <td>{user.isEmailConfirmed ? "✅ Yes" : "❌ No"}</td>
                <td style={{ cursor: "pointer" }} onClick={() => EmailConfirmation(user)}>
                  {user.isEmailConfirmed ? "✅ Yes" : "❌ No"}
                </td>
                <td style={{ cursor: "pointer" }} onClick={() => deleteuser(user.id)}>
                  ❌
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Users;
